"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var restorationPrioritiesHelpers_exports = {};
__export(restorationPrioritiesHelpers_exports, {
  biologicalColor: () => biologicalColor,
  biologicalPriorityAttribute: () => biologicalPriorityAttribute,
  chemicalColor: () => chemicalColor,
  chemicalPriorityAttribute: () => chemicalPriorityAttribute,
  hydrologicalColor: () => hydrologicalColor,
  hydrologicalPriorityAttribute: () => hydrologicalPriorityAttribute,
  lakeRestorationPrioritiesAttributeGroups: () => lakeRestorationPrioritiesAttributeGroups,
  lakesSource: () => lakesSource,
  overallColor: () => overallColor,
  overallPriorityAttribute: () => overallPriorityAttribute,
  physicalColor: () => physicalColor,
  physicalPriorityAttribute: () => physicalPriorityAttribute,
  presenceBuckets: () => presenceBuckets,
  riverAreasSource: () => riverAreasSource,
  riverRestorationPrioritiesAttributeGroups: () => riverRestorationPrioritiesAttributeGroups,
  riversSource: () => riversSource
});
module.exports = __toCommonJS(restorationPrioritiesHelpers_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_core = require("../../core/index.js");
const lakesSource = (0, import_core.cartographerSourceWithDefaults)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neLakeRestorationPriorities"),
  simplifyZoom: 10,
  attribution: []
});
const riversSource = (0, import_core.cartographerSourceWithDefaults)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverRestorationPriorities"),
  simplifyZoom: 10,
  attribution: []
});
const riverAreasSource = (0, import_core.cartographerSourceWithDefaults)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverRestorationPriorityAreas"),
  simplifyZoom: 6,
  attribution: []
});
const overallColor = "yellow";
const physicalColor = "orange";
const hydrologicalColor = "cyan";
const chemicalColor = "magenta";
const biologicalColor = "lime";
function presenceBuckets(baseColor) {
  return (0, import_topo_map.standardBuckets)([
    (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor(baseColor), "Yes"),
    (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("#eee"), "No"),
    (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "Unknown")
  ]);
}
const overallPriorityAttribute = (0, import_topo_map.booleanAttr)({
  attributeId: "allComponents",
  label: "Restoration Priority (Any Component)",
  buckets: presenceBuckets(overallColor),
  showDistribution: false
});
const physicalPriorityAttribute = (0, import_topo_map.booleanAttr)({
  attributeId: "physical",
  label: "Physical Restoration Priority (Any Measure)",
  buckets: presenceBuckets(physicalColor),
  showDistribution: false
});
const hydrologicalPriorityAttribute = (0, import_topo_map.booleanAttr)({
  attributeId: "hydrological",
  label: "Hydrological Restoration Priority (Any Measure)",
  buckets: presenceBuckets(hydrologicalColor),
  showDistribution: false
});
const chemicalPriorityAttribute = (0, import_topo_map.booleanAttr)({
  attributeId: "chemical",
  label: "Chemical Restoration Priority (Any Measure)",
  buckets: presenceBuckets(chemicalColor),
  showDistribution: false
});
const biologicalPriorityAttribute = (0, import_topo_map.booleanAttr)({
  attributeId: "biological",
  label: "Biological Restoration Priority (Any Measure)",
  buckets: presenceBuckets(biologicalColor),
  showDistribution: false
});
function riverRestorationPrioritiesAttributeGroups(locationAttribute) {
  return [
    (0, import_topo_map.attributeGroup)({
      label: "General",
      attributes: [locationAttribute, overallPriorityAttribute]
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Physical",
      attributes: [
        physicalPriorityAttribute,
        ...import_inventory_enums.NeRiverRestorationPrioritiesPhysicalMeasureEnum.entries.map(
          (entry) => (0, import_topo_map.booleanAttr)({
            attributeId: `physicalMeasure${entry.value}`,
            label: entry.label,
            buckets: presenceBuckets(physicalColor),
            showDistribution: false
          })
        )
      ]
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Hydrological",
      attributes: [
        hydrologicalPriorityAttribute,
        ...import_inventory_enums.NeRiverRestorationPrioritiesHydrologicalMeasureEnum.entries.map(
          (entry) => (0, import_topo_map.booleanAttr)({
            attributeId: `hydrologicalMeasure${entry.value}`,
            label: entry.label,
            buckets: presenceBuckets(hydrologicalColor),
            showDistribution: false
          })
        )
      ]
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Chemical",
      attributes: [
        chemicalPriorityAttribute,
        ...import_inventory_enums.NeRiverRestorationPrioritiesChemicalMeasureEnum.entries.map(
          (entry) => (0, import_topo_map.booleanAttr)({
            attributeId: `chemicalMeasure${entry.value}`,
            label: entry.label,
            buckets: presenceBuckets(chemicalColor),
            showDistribution: false
          })
        )
      ]
    }),
    (0, import_topo_map.attributeGroup)({
      label: "Biological",
      attributes: [
        biologicalPriorityAttribute,
        ...import_inventory_enums.NeRiverRestorationPrioritiesBiologicalMeasureEnum.entries.map(
          (entry) => (0, import_topo_map.booleanAttr)({
            attributeId: `biologicalMeasure${entry.value}`,
            label: entry.label,
            buckets: presenceBuckets(biologicalColor),
            showDistribution: false
          })
        )
      ]
    })
  ];
}
const lakeRestorationPrioritiesAttributeGroups = [
  (0, import_topo_map.attributeGroup)({
    label: "General",
    attributes: [
      (0, import_topo_map.stringAttr)({
        attributeId: "lakeName",
        label: "Lake Name",
        buckets: "auto",
        showDistribution: false
      }),
      overallPriorityAttribute
    ]
  }),
  (0, import_topo_map.attributeGroup)({
    label: "Physical",
    attributes: [
      physicalPriorityAttribute,
      ...import_inventory_enums.NeLakeRestorationPrioritiesPhysicalMeasureEnum.entries.map(
        (entry) => (0, import_topo_map.booleanAttr)({
          attributeId: `physicalMeasure${entry.value}`,
          label: entry.label,
          buckets: presenceBuckets(physicalColor),
          showDistribution: false
        })
      )
    ]
  }),
  (0, import_topo_map.attributeGroup)({
    label: "Hydrological",
    attributes: [
      hydrologicalPriorityAttribute,
      ...import_inventory_enums.NeLakeRestorationPrioritiesHydrologicalMeasureEnum.entries.map(
        (entry) => (0, import_topo_map.booleanAttr)({
          attributeId: `hydrologicalMeasure${entry.value}`,
          label: entry.label,
          buckets: presenceBuckets(hydrologicalColor),
          showDistribution: false
        })
      )
    ]
  }),
  (0, import_topo_map.attributeGroup)({
    label: "Chemical",
    attributes: [
      chemicalPriorityAttribute,
      ...import_inventory_enums.NeLakeRestorationPrioritiesChemicalMeasureEnum.entries.map(
        (entry) => (0, import_topo_map.booleanAttr)({
          attributeId: `chemicalMeasure${entry.value}`,
          label: entry.label,
          buckets: presenceBuckets(chemicalColor),
          showDistribution: false
        })
      )
    ]
  }),
  (0, import_topo_map.attributeGroup)({
    label: "Biological",
    attributes: [
      biologicalPriorityAttribute,
      ...import_inventory_enums.NeLakeRestorationPrioritiesBiologicalMeasureEnum.entries.map(
        (entry) => (0, import_topo_map.booleanAttr)({
          attributeId: `biologicalMeasure${entry.value}`,
          label: entry.label,
          buckets: presenceBuckets(biologicalColor),
          showDistribution: false
        })
      )
    ]
  })
];
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  biologicalColor,
  biologicalPriorityAttribute,
  chemicalColor,
  chemicalPriorityAttribute,
  hydrologicalColor,
  hydrologicalPriorityAttribute,
  lakeRestorationPrioritiesAttributeGroups,
  lakesSource,
  overallColor,
  overallPriorityAttribute,
  physicalColor,
  physicalPriorityAttribute,
  presenceBuckets,
  riverAreasSource,
  riverRestorationPrioritiesAttributeGroups,
  riversSource
});
//# sourceMappingURL=restorationPrioritiesHelpers.js.map
